<router-outlet>
  <app-loading></app-loading>
</router-outlet>
